import axios from 'axios';
import { url } from '../config';

// Redux Actions
import { SET_IMAGE_START, SET_IMAGES } from '../actions/index.jsx';

export const getPostImage = (id) => {
    return function (dispatch) {
        dispatch({ type: SET_IMAGE_START });
        axios
            .get(`${url}/wp-json/wp/v2/posts/${id}`)
            .then((response) => {
                dispatch({
                    type: SET_IMAGES,
                    images: response.data,
                });
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/getimage_request.js